<template>
  <suggestions v-model="setQuery"
               :options="{inputClass: 'form-control autocomplete', placeholder: 'Поиск по коду комплекта'}"
               :disabled="setId"
               :onItemSelected="onSetSelected"
               :onInputChange="onSetSearch">
    <div slot="item" slot-scope="props" class="single-item">
      <div class="name"><b>{{ props.item.code }}</b></div>
      <div class="name">{{ props.item.price | currency }}&nbsp;₽</div>
      <div class="name">{{ props.item.name }}</div>
    </div>
  </suggestions>
</template>

<script>
import 'v-suggestions/dist/v-suggestions.css'
import Suggestions from 'v-suggestions'

export default {
  components: {
    Suggestions
  },
  props: {
    setId: {
      validator: (val) => Number.isInteger(val) || val === null,
      default: null
    }
  },
  data () {
    return {
      setQuery: '',
      sets: []
    }
  },

  async created () {
    const resp = await window.axios.get(this.route('backend.sets.search'))
    this.sets = resp.data.data

    if (this.setId) {
      const set = this.sets.find(set => set.id === this.setId)
      if (set) {
        this.onSetSelected(set)
      }
    }
  },

  methods: {
    /**
     * Обработчик выбора в списке подсказок автокомплита комплектов
     */
    onSetSelected (item) {
      this.setQuery = item.code
      this.$emit('input', item)
    },

    /**
     * Обработчик инпута автокомплита комплектов
     */
    onSetSearch (setQuery) {
      if (setQuery.trim().length === 0) {
        return null
      }

      const result = []

      this.sets.forEach((item) => {
        if (
          (typeof item.code === 'string' && item.code.toLowerCase().includes(setQuery.toLowerCase())) ||
            (typeof item.name === 'string' && item.name.toLowerCase().includes(setQuery.toLowerCase()))
        ) {
          result.push(item)
        }
      })

      return result
    }
  },

  watch: {},

  computed: {}
}
</script>

<style>
.v-suggestions .suggestions {
  max-height: 200px;
  overflow-y: scroll;
}
</style>
